<template>
  <div :style="{ position: 'relative' }">
    <Loading
      :active.sync="loading"
      :isFullPage="false"
      :zIndex="9000"
    ></Loading>
    <Toast :style="{ width: $isMobile() ? '100vw' : '' }" />
    <Dialog
      id="'dialog-confirm-data'"
      :visible.sync="show"
      :style="{ width: $isMobile() ? '100vw' : '40vw' }"
      v-bind:class="[{ 'p-dialog-maximized': $isMobile() }]"
      :modal="true"
      :header="'Confirmar Dados dos Equipamentos'"
    >
      <h5>Dados da Reparação</h5>
      <form
        name="confirmEquipamentDataForm"
        class="p-col-12"
        @submit.prevent="confirmEquipamentData"
      >
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-12" style="margin-top: 10px">
            <span class="p-float-label">
              <InputText
                id="brand"
                name="brand"
                type="text"
                v-model="brand"
                v-validate="'required'"
              />
              <label for="brand">Marca</label>
            </span>
          </div>
          <div class="p-field p-col-12 p-md-12" style="margin-top: 10px">
            <span class="p-float-label">
              <InputText
                id="model"
                name="model"
                type="text"
                v-model="model"
                v-validate="'required'"
              />
              <label for="model">Modelo</label>
            </span>
          </div>
          <div class="p-field p-col-12 p-md-12" style="margin-top: 10px">
            <span class="p-float-label">
              <InputText
                id="serialNumber"
                name="serialNumber"
                type="text"
                v-model="serial_number"
                v-validate="'required'"
              />
              <label for="serialNumber">Número de Série</label>
            </span>
          </div>
          <div class="p-field p-col-12 p-md-12" style="margin-top: 10px">
            <span class="p-float-label">
              <InputMask
                id="endWarranty"
                name="endWarranty"
                type="text"
                v-model="end_warranty"
                mask="9999-99-99"
                slotChar="yyyy-mm-dd"
              />
              <label for="endWarranty">Data de Fim da Garantia</label>
            </span>
          </div>
        </div>
      </form>
      <template #footer>
        <Button
          :label="'Guardar'"
          icon="pi pi-save"
          class="p-button-success"
          @click="confirmEquipamentData"
        />
        <Button
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-danger"
          @click="close"
        />
      </template>
    </Dialog>

    <Dialog header="Confirmar Equipamento" :visible.sync="showConfirmationEquipment" :style="{width: '400px'}" modal>
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color: #fbc02d" />
        <span>Deseja continuar e relacionar com o equipamento já existente?</span>
        <p class="p-mt-2 text-muted"><small>Já existe um equipamento com os seguintes dados:</small></p>
        <ul class="p-mt-2" v-if="existing_equipment">
          <li><strong>Marca:</strong> {{ existing_equipment.brand }}</li>
          <li><strong>Modelo:</strong> {{ existing_equipment.model }}</li>
          <li><strong>Número de Série:</strong> {{ existing_equipment.serial_number }}</li>
        </ul>
      </div>
      <template #footer>
        <Button label="Não" icon="pi pi-times" class="p-button-text" @click="showConfirmationEquipment = false" />
        <Button label="Sim, Continuar" icon="pi pi-check" class="p-button-success" :loading="loading" @click="saveData(true)" />
      </template>
    </Dialog>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import supportService from "../../services/support.service";
export default {
  name: "ConfirmEquipamentData",
  props: ["show", "service"],
  components: { Loading },
  watch: {
    async show() {
      if (this.show === true) {
        this.brand = this.service.pat_brand;
        this.model = this.service.pat_model;
        this.serial_number = this.service.pat_serial_number;
        this.end_warranty = this.service.equipament_end_warranty;
        this.task_id = this.service.id;
        this.$validator.resume();
      } else {
        this.reset();
      }
    },
  },
  data() {
    return {
      loading: false,
      brand: null,
      model: null,
      serial_number: null,
      end_warranty: null,
      task_id: null,
      showConfirmationEquipment: false,
      existing_equipment: null,
    };
  },
  methods: {
    reset() {
      this.brand = null;
      this.model = null;
      this.serial_number = null;
      this.end_warranty = null;
      this.task_id = null;
      return (this.loading = false);
    },
    close() {
      this.reset();
      this.$validator.pause();
      return this.$emit("close");
    },
    confirmEquipamentData() {
      this.$validator.validateAll().then(async (isValid) => {
        if (!isValid) {
          this.loading = false;
          return;
        }
        this.$validator.pause();
        return await this.saveData();
      });
    },
    async saveData(confirmation = false) {
      this.loading = true;
      let data = {
        brand: this.brand,
        model: this.model,
        serial_number: this.serial_number,
        end_warranty: this.end_warranty,
      };
      if (this.end_warranty !== null && this.end_warranty !== '') {

        data.end_warranty = this.end_warranty;
      }
      if (confirmation) {
        data.confirmation = true;
      }

      try {
        const response = await supportService.updateEquipamentData(this.task_id, data);
        this.loading = false;

        this.showConfirmationEquipment = false;

        return this.$emit("updatedData", response);
      } catch (error) {
        this.loading = false;

        if (error && error.data && error.data.confirmation_required) {
          this.existing_equipment = error.data.existing_equipment;
          this.showConfirmationEquipment = true;
          return;
        }

        if (error && error.data && error.data.message) {
          this.$toast.add({
            severity: "error",
            summary: "Erro",
            detail: error.data.message,
            life: 5000,
          });

          return;
        }

        this.$toast.add({
          severity: "error",
          summary: "Erro",
          detail: "Erro ao guardar os dados do equipamento",
          life: 3000,
        });
      }
    }
  },
};
</script>
